import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

const Orcamentos = (props) => {
	//meta title
	document.title = "Senda | Orçamentos";

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					{/* Render Breadcrumb */}
					<Breadcrumbs
						title={props.t("Orçamentos")}
						breadcrumbItem={props.t("Orçamentos")}
					/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withTranslation()(Orcamentos);
